<template>
  <div ref="clipboardSnackbar" class="clipboard-snackbar p-2 bg-dark">
    <p class="headline m-0 text-center text-white">
      クリップボードにコピーしました。
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opacityTimeout: null,
      visibleTimeout: null,
    };
  },
  methods: {
    triggerSnackbar() {
      clearTimeout(this.opacityTimeout);
      clearTimeout(this.visibleTimeout);

      const ref = this.$refs.clipboardSnackbar;

      ref.style.opacity = "1";
      ref.style.visibility = "visible";

      this.opacityTimeout = setTimeout(() => {
        ref.style.opacity = "0";

        this.visibleTimeout = setTimeout(() => {
          ref.style.visibility = "hidden";
        }, 500);
      }, 1500);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.clipboard-snackbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  visibility: hidden;
}
</style>
